import { Directive, ElementRef, Input, SimpleChanges } from '@angular/core';

import { OutBoxStatus } from '../api/models';

@Directive({
  selector: '[outBoxStatusIcon]',
  standalone: true,
})
export class OutBoxStatusIconDirective {
  @Input('outBoxStatusIcon') status: OutBoxStatus;

  constructor(private element: ElementRef<HTMLElement>) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.element.nativeElement.className = this.getCssClassList();
  }

  getCssClassList(): string {
    let classList = 'mdi ';

    switch (this.status) {
      //waiting

      case OutBoxStatus.IsBeingSent:
        classList += 'mdi-circle-slice-4 mdi-22px text-primary mdi-spin';
        break;
      case OutBoxStatus.WatingForSend:
        classList += 'mdi-lock-reset mdi-22px text-warning mdi-spin';
        break;
      case OutBoxStatus.WatingForConfirm:
        classList += 'mdi-lock-reset mdi-22px text-warning mdi-spin';
        break;
      //error
      case OutBoxStatus.ErrorInSending:
      case OutBoxStatus.ErrorInGetItc:
        classList += 'mdi-alert-circle-outline mdi-21px text-danger';
        break;
      //success
      case OutBoxStatus.Sent:
        classList += 'mdi-check-bold text-success mdi-22px';
        break;
      //success
      case OutBoxStatus.SentAndGiveBackCredit:
        classList += 'mdi-check-circle-outline text-success mdi-22px';
        break;
      //Stored
      case OutBoxStatus.Stored:
        classList += 'mdi-content-save text-gray mdi-22px';
        break;
      //Archived
      case OutBoxStatus.Archived:
        classList += 'mdi-archive text-info mdi-22px ';
        break;
      case OutBoxStatus.Archiving:
        classList += 'mdi-archive text-info mdi-22px opacity-anim';
        break;
      //BlackList
      case OutBoxStatus.BlackList:
        classList += 'mdi-block-helper text-dark mdi-22px';
        break;
      case OutBoxStatus.SentAndSavedIds:
        classList += 'mdi-send text-primary mdi-20px';
        break;

      case OutBoxStatus.CalculationError:
        classList += 'mdi-calculator text-danger mdi-20px';
        break;

      case OutBoxStatus.StoppedByUser:
        classList += 'mdi-stop text-danger mdi-20px';
        break;

      default:
        break;
    }

    return classList;
  }
}
